

export const getProducts = state =>  state.productsPresentationData.products;